"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../../assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.pavement};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(22, 21, 29, 0.1);
  display: flex;
  height: 140px;
  justify-content: space-between;
  margin: 20px 0;
  padding: 25px 20px;
`;
